module.exports = function (app) {
    app.controller('pages.register.createLogin', ['$state', '$scope', '$window', '$filter', 'registrationUser', 'registration', 'sessionData', 'registerNotifications', 'contentResourceServices', 'coremetrics','brand',
        function ($state, $scope, $window, $filter, registrationUser, registration, sessionData, registerNotifications, contentResourceServices, coremetrics, brand) {

            coremetrics.startConversion('CREATE LOGIN STEP', 'REGISTRATION');

            $scope.scrollTo('chevron-container');

            var identifyResponse = {};
            var defaults = {
                securityStrengthRule: {
                    passwordLengthRule: {
                        minLength: 8,
                        maxLength: 64
                    }
                }
            };
            // Guarantee object structure and mixin defaults if not present.
            angular.extend(identifyResponse, defaults, registrationUser.identifyResponse);

            $scope.userType = $state.params.userType;
            $scope.isMINCR = (brand.current.sharedBrandCode === 'mincr') ? true : false;
            $scope.disableForm = false;
            $scope.showOkButton = false;
            $scope.user = registrationUser.user;
            $scope.chevron.parameters = { user : $scope.user, identifyResponse: identifyResponse };
            $scope.user.password = '';
            $scope.user.verifiedPassword = '';
            $scope.user.securityQuestion = '';
            $scope.user.securityAnswer = '';
            $scope.criteria = {};
            $scope.notifications = [];
            $scope.passwordRules = {
                minLength: identifyResponse.securityStrengthRule.passwordLengthRule.minLength,
                maxLength: identifyResponse.securityStrengthRule.passwordLengthRule.maxLength
            };

            $scope.securityQuestionList = identifyResponse.questionList;

            $scope.showSecurityQuestion = (sessionData.appConfig.REGISTER && sessionData.appConfig.REGISTER.SECURITY_QUESTION) ? sessionData.appConfig.REGISTER.SECURITY_QUESTION.booleanValue : false;

            $scope.updateCurrentChevronStep();

            var filterFn = registration.notificationFilter('alert', 'register.createLogin');
            contentResourceServices.updateResourcesAsync(registerNotifications, filterFn, "Bluecore Notification").then(function(items){
                $scope.notifications = items;
            });

            $scope.register = function () {
                $scope.user.username = $scope.isMINCR ? $scope.user.uppercaseUsername.toUpperCase() : $scope.user.username;
                $scope.currentNotification = '';
                if ($scope.createLoginForm && $scope.createLoginForm.$valid) {
                    coremetrics.elementTag('REGISTRATION:CREATE LOGIN SUBMIT', 'REGISTRATION');
                    $scope.disableForm = true;
                    $scope.currentNotification = registration.notifications.registerPleaseWait;

                    //disable the chevron (Make the current step appear to have no valid steps for navigation).
                    $scope.chevron.steps[$scope.chevron.step-1].validSteps = [ 0 ];

                    if($scope.userType == 'medicareVisitor' || $scope.userType == 'highmarkVisitor'){
                        registration.oldRegister($scope.user, $scope.userType).then( function(response) {
                            $scope.currentNotification = registration.notifications.loginPleaseWait;
                            registration.loginShop($scope.user).then( function(response) {
                                coremetrics.finishConversion('VISITOR REGISTRATION LOGIN', 'REGISTRATION');
                                if ($scope.userType === "medicareVisitor") {
                                    $window.location.href = "/#" + $state.params.originalUrl;
                                } else {
                                    $window.location.href = $state.params.originalUrl;
                                }
                            }, function(error) {
                                coremetrics.elementTag('REGISTRATION:CREATE LOGIN OK', 'REGISTRATION');

                                $scope.showOkButton = true;
                                $scope.currentNotification = registration.notifications.registerPassLoginFail;
                            });
                        }, function(error) {
                            // Re-enable chevron navigation
                            delete $scope.chevron.steps[$scope.chevron.step-1].validSteps;
                            $scope.disableForm = false;
                            var nf = $filter('filter')($scope.notifications, { id: error.returnCodeDescription });
                            $scope.currentNotification = (nf.length > 0 ? error.returnCodeDescription : registration.notifications.defaultError);
                        });
                    }else{
                        registration.register($scope.user, $scope.userType).then( function(response) {
                            $scope.currentNotification = registration.notifications.loginPleaseWait;

                            coremetrics.finishConversion('CREATE LOGIN STEP', 'REGISTRATION');
                            coremetrics.finishConversion('MEMBER REGISTRATION', 'REGISTRATION');
                            coremetrics.startConversion('MEMBER REGISTRATION LOGIN', 'REGISTRATION');
                                
                            registration.loginMember($scope.user, $scope.campaignID, $scope.userType).then( function(response) {
                                //Login success, user will be directed to member landing or campaign page.
                                coremetrics.finishConversion('MEMBER REGISTRATION LOGIN', 'REGISTRATION');

                            }, function(error) {
                                $scope.showOkButton = true;
                                $scope.currentNotification = registration.notifications.registerPassLoginFail;
                            });

                        }, function(error) {
                            // Re-enable chevron navigation
                            delete $scope.chevron.steps[$scope.chevron.step-1].validSteps;
                            $scope.disableForm = false;
                            var nf = $filter('filter')($scope.notifications, { id: error.returnCodeDescription });
                            $scope.currentNotification = (nf.length > 0 ? error.returnCodeDescription : registration.notifications.defaultError);

                            coremetrics.pageviewTag('REGISTRATION CREATE LOGIN:' + $scope.currentNotification, 'REGISTRATION');
                        });
                    }
                }
            };

            $scope.cancelButton = function() {
                coremetrics.elementTag('REGISTRATION:CREATE LOGIN BACK', 'REGISTRATION');

                $state.go($scope.getPreviousStateFromChevron(),  $scope.chevron.parameters);
            };

            $scope.okButton = function() {
                coremetrics.elementTag('REGISTRATION:CREATE LOGIN OK', 'REGISTRATION');
                if($scope.userType == 'medicareVisitor' || $scope.userType == 'medicareMember'){
                    $window.location.href = "/#" + $state.params.originalUrl;
                }else if($scope.userType == 'highmarkVisitor' || $scope.userType == 'highmarkMember'){
                    $window.location.href = "/sales/#!/find-insurance/build-your-family";
                }else{
                    $window.location = '/member/home';
                }
            };
        }
    ]);

    //TODO: Break out into a directive once we migrate to a new standalone project for LARG.
    //TODO: Replace code in account recovery / temp password to use this validator instead of existing on-change on-blur logic.
    app.directive('memberPasswordValidator', function () {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                criteria: '=memberPasswordValidator'
            },
            link: function (scope, element, attrs, ctrl) {
                scope.criteria = scope.criteria || {};

                ctrl.$validators.passwordRules = function (modelValue, viewValue) {
                    var count = 0;
                    scope.criteria = {};

                    if (viewValue && viewValue !== undefined) {
                        if (viewValue.length >= attrs.minlength && viewValue.length <= attrs.maxlength) {
                            scope.criteria.hasValidLength = true;
                        }
                        if (/[0-9]/.test(viewValue)) {
                            scope.criteria.hasOneNumber = true;
                            count++;
                        }
                        if (/[#!@$%^&*\(\)\-_=+|;:'",<.>?`~\\\/\[\]\{\}]/.test(viewValue)) {
                            scope.criteria.hasSpecialCharacter = true;
                            count++;
                        }
                        if (viewValue.toLowerCase() !== viewValue) {
                            scope.criteria.hasUpperCase = true;
                            count++;
                        }
                        if (viewValue.toUpperCase() !== viewValue) {
                            scope.criteria.hasLowerCase = true;
                            count++;
                        }
                        scope.criteria.hasPassed = (count > 2);

                        return !!scope.criteria.hasPassed;
                    }
                    return true;
                };

                ctrl.$validators.containSpace = function (modelValue, viewValue) {
                    if (viewValue && viewValue !== undefined) {
                        var trimmedPassword = viewValue.replace(/\s/g, '');
                        return trimmedPassword === viewValue;
                    }
                    return true;
                };
            }
        };
    });


};
